import { Appointment } from 'fhir/r4';
import { Event as VigidEvent } from '../events/events.service';

export type ActivityType = 'appointment' | 'telemedicine' | 'event';

export interface UnifiedActivity {
  id: string;
  title: string;
  start: string; // ISO string
  end?: string;
  type: ActivityType;
  status?: string;
  location?: string;
  isVirtual?: boolean;
  meetingUrl?: string;
  registrationUrl?: string;
  sourceType: 'Appointment' | 'Event';
  raw: Appointment | VigidEvent;
}

// --- Appointment -> UnifiedActivity -------------------------------------

export function mapAppointmentToActivity(appt: Appointment, isTelemedicine: boolean): UnifiedActivity {
  const meetingUrl = (appt as any)?.zoomMeetingUrl
    || (appt as any)?.meetingLink
    || undefined;

  return {
    id: appt.id ?? '',
    title: appt.description
      || appt.serviceType?.[0]?.text
      || appt.serviceType?.[0]?.coding?.[0]?.display
      || (isTelemedicine ? 'Telemedicine consultation' : 'Appointment'),
    start: appt.start || appt.requestedPeriod?.[0]?.start || '',
    end: appt.end,
    type: isTelemedicine ? 'telemedicine' : 'appointment',
    status: appt.status,
    isVirtual: isTelemedicine,
    meetingUrl,
    sourceType: 'Appointment',
    raw: appt
  };
}

// --- Event -> UnifiedActivity --------------------------------------------

export function mapEventToActivity(event: VigidEvent): UnifiedActivity {
  return {
    id: event.id,
    title: event.title,
    start: event.start,
    end: event.end,
    type: 'event',
    location: event.location,
    isVirtual: !!(event.meetingUrl || event.externalMeetingHostUrl),
    meetingUrl: event.meetingUrl || event.externalMeetingHostUrl,
    registrationUrl: event.registrationUrl,
    sourceType: 'Event',
    raw: event
  };
}

